import { Config } from '@/core/config/config';
import { supplierService } from '@/projects/platform/services/account-supplier-service';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { Button, Button as DXButton, LoadPanel, Popup } from 'devextreme-react';
import DataGrid, { Toolbar, Item } from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { t } from 'i18next';
import { useCallback, useRef, useState } from 'react'
import React from 'react';
import { alert, confirm } from 'devextreme/ui/dialog';
import PermissionWrapper from '@/core/wrappers/permission-wrapper';
import { toast } from 'react-toastify';
import { ApprovalRequestTimeline } from '_metronic/partials/layout/approval-request/approval-request-history';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

function NewRetailerList(props: any) {
  const [loadPanelVisible, setLoadPanelVisible] = useState(false);
  const gridRef: any = useRef<DataGrid>();
  const [approvalHistoryPopupVisible, setApprovalHistoryPopupVisible] = useState(false);
  const [currentApprovalSteps, setCurrentApprovalSteps] = useState([]);
  const [mainStore] = useState(() => createCustomStore({
    key: ['id'],
    load: supplierService.getRetailerRelationRequests,
    byKey:(key, loadOptions) => {
      if (key) {
        loadOptions.filter = ["Id", "=", key];
      }
    },
    insert: supplierService.createRetailerRelationRequest,
    useDefaultSearch: true
  }));

  const [retailerStore] = useState(() => createCustomStore({
    key: 'id',
    load: supplierService.lookupRetailers,
    byKey: (key, loadOptions) => {
      if (key) {
        loadOptions.filter = ["id", "=", key];
      }
    },
  }));


  const handleRowUpdating = async (e: any) => {
    e.newData = { ...e.oldData, ...e.newData }
  };

  const onEditorPreparing = async (e: any) => {
    if (e.parentType == "dataRow") {
      if (e.dataField === "status" && e.row && e.row.isNewRow) {
        e.editorOptions.disabled = true;
      }
    }
  };

  const isWithdrawIconVisible = (e: any) => !e.row.isEditing;

  const withdrawRequest = async (e: any) => {
    const result = confirm("<i>" + t("are_you_sure") + "</i>", t("withdraw_request"));
    result.then(async (dialogResult: any) => {
      if (dialogResult) {
        try {
          setLoadPanelVisible(true);
          await supplierService.withdrawRetailerRelationRequest({ id: e.row.data.id });
          setLoadPanelVisible(false);
          await gridRef.current?.instance.refresh();
        } catch (error: any) {
          toast.error(error.response.data.message);
          setLoadPanelVisible(false);
        }
      }
    });

  }

    const onApprovalHistoryPopupHiding = useCallback(() => {
      setApprovalHistoryPopupVisible(false);
    }, [setApprovalHistoryPopupVisible]);


  return (
    <div className='view-wrapper'>
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        visible={loadPanelVisible}
        showIndicator={true}
        shading={true}
        showPane={true}
        hideOnOutsideClick={false}
        message={t("saving_please_wait")}

      />
      <DataGridWrapper
        gridRef={gridRef}
        datasource={mainStore}
        remoteOperations={true}
        onRowUpdating={handleRowUpdating}
        onEditorPreparing={onEditorPreparing}
        filterVisible={true}
        headerFilterVisible={true}
        editingConfig={{ mode: 'row', useIcons: true, allowAdding: true, allowUpdating: false, allowDeleting: false }}
        pagerVisible={true}
        columns={[
          {
            dataField: 'fromId',
            caption: t('retailer'),
            allowFiltering: false,
            required: true,
            lookup: {
              dataSource: retailerStore,
              valueExpr: "id",
              displayExpr: "name"
            }
          },
          {
            dataField: 'fromValue',
            caption: t('retailerCode'),
            allowFiltering: true,
            width: 180
          },
          {
            dataField: 'defaultStockShare',
            caption: t('defaultStockShare'),
            allowFiltering: false,
            dataType: 'boolean',
            disabled: false,
            calculateCellValue: (rowData: any) => {
              return rowData.defaultStockShare || false;
            },
            width: 270
          },
          {
            dataField: 'defaultSalesShare',
            caption: t('defaultSalesShare'),
            allowFiltering: false,
            disabled: false,
            dataType: 'boolean',
            calculateCellValue: (rowData: any) => {
              return rowData.defaultSalesShare || false;
            },
            width: 270
          },
          {
            dataField: 'status',
            caption: t('status'),
            allowFiltering: false,
            allowAdding: false
          },
          {
            type: 'buttons',
            width: 80,
            buttons: [
              {
                name: 'save',
              },
              {
                name: 'cancel',
              },
              {
                icon: 'ordersbox',
                hint: t("request_history"),
                visible: ((e: any) => !e.row.isEditing && e.row.data.approvalSteps && e.row.data.approvalSteps.length > 0),
                onClick: (e: any) => {

                  if (e.row.data.approvalSteps && e.row.data.approvalSteps.length > 0) {
                    setCurrentApprovalSteps(e.row.data.approvalSteps)
                    setApprovalHistoryPopupVisible(true)
                  }
                }
              },
              {
                icon: 'trash',
                hint: t("withdraw_request"),
                visible: isWithdrawIconVisible,
                onClick: withdrawRequest
              }
            ]
          }
        ]}
      />

      <Popup
        visible={approvalHistoryPopupVisible}
        onHiding={onApprovalHistoryPopupHiding}
        showTitle={true}
        width={600}
        height={400}
        position={{
          of: window,
          at: 'center',
          my: 'center'
        }}
        title={t("approval_history")}
      >
        <ApprovalRequestTimeline timelines={currentApprovalSteps} height='250px' />

      </Popup>

    </div>
  );
}
export default NewRetailerList